import gtag from "ga-gtag"

export const onContactUsBtnClick = (ctaTitle, setShowContactFormWindow) => {
  setShowContactFormWindow(true)

  gtag("event", ctaTitle, {
    event_category: "contact-us",
    event_label: "Contact Form",
  })
}
